import { initializeApp } from "firebase/app";

import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";

import { getFirestore } from "firebase/firestore";

import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAB7Ek9ULd9KsVWbNvjPrNu5f1YEicsEdI",
  authDomain: "refer-hotel.firebaseapp.com",
  projectId: "refer-hotel",

  // Firebase Console me jo actual bucket dikh raha hai
  storageBucket: "refer-hotel.firebasestorage.app",

  messagingSenderId: "724857326404",
  appId: "1:724857326404:web:f66ac1ead5b6a0c83ce511",
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);

/*
 * Explicit bucket URL use kar rahe hain taaki SDK
 * galti se purane refer-hotel.appspot.com bucket ko use na kare.
 */
export const storage = getStorage(
  app,
  "gs://refer-hotel.firebasestorage.app"
);

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Auth persistence enabled");
    console.log(
      "Firebase Storage bucket:",
      storage.app.options.storageBucket
    );
  })
  .catch((error) => {
    console.error("Persistence error:", error);
  });

export default app;